module.exports = __webpack_public_path__ + "static/media/badgeMod.3527dbc1.svg";